import type { PropsWithChildren } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { authClient } from "../lib/authClient";

export function RequireAuth({ children }: PropsWithChildren) {
  const location = useLocation();
  const sessionQuery = authClient.useSession();

  if (sessionQuery.isPending) {
    return (
      <div className="page-centered">
        <span>Carregando sessão...</span>
      </div>
    );
  }

  if (!sessionQuery.data?.session) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return children;
}
